import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/onboarding/",
)({
  beforeLoad: async ({ context }) => {
    const answers =
      await context.trpcQueryUtils.account.getWelcomeAnswers.ensureData();
    if (!answers?.tools) {
      throw redirect({ to: "/onboarding/tools" });
    }
    if (!answers?.platforms) {
      throw redirect({ to: "/onboarding/platforms" });
    }
    throw redirect({ to: "/onboarding/paywall" });
  },
  component: OnboardingIndex,
});

function OnboardingIndex() {
  return null;
}
